import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  Ch_generateLaboratoryPrescriptionDocumentInput,
  useChGenerateLaboratoryPrescriptionMutation as useChGenerateLaboratoryPrescriptionMutationType,
} from "@/modules/patients/detail/laboratory-prescription/ch/services/__generated__/useChGenerateLaboratoryPrescriptionMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const mutation = graphql`
  mutation useChGenerateLaboratoryPrescriptionMutation($input: Ch_generateLaboratoryPrescriptionDocumentInput!) {
    ch_generateLaboratoryPrescriptionDocument(input: $input) {
      ch_LaboratoryPrescription {
        id
        fileId
        ...chLaboratoryPrescriptionDrawerFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChGenerateLaboratoryPrescriptionMutationType>, "variables"> & {
  id: Ch_generateLaboratoryPrescriptionDocumentInput["id"]
  medgateConnectOrderCode?: Ch_generateLaboratoryPrescriptionDocumentInput["medgateConnectOrderCode"]
}

const useChGenerateLaboratoryPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChGenerateLaboratoryPrescriptionMutationType>(
    mutation,
    params,
  )
  const patientById = usePatientParam()

  const commitHandler = useCallback(
    async (config: Config) => {
      const { id, medgateConnectOrderCode } = config

      commit({
        variables: { input: { id, medgateConnectOrderCode, patientId: patientById } },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useChGenerateLaboratoryPrescriptionMutation }
